import React from 'react';
import { Link } from 'react-router-dom';
import isologo from '../../assets/images/toyo-isologo-dark.png';
import puertaJapon from '../../assets/images/footer-bg-japon.svg';

// Importar imágenes de íconos personalizados
import instagramIcon from '../../assets/images/footer-icono-instagram.svg';
import twitterIcon from '../../assets/images/footer-icono-twitter.svg';
import tiktokIcon from '../../assets/images/footer-icono-tiktok.svg';
import youtubeIcon from '../../assets/images/footer-icono-youtube.png';
import twitchIcon from '../../assets/images/footer-icono-twitch.svg';
import discordIcon from '../../assets/images/footer-icono-discord.svg';
import linkedinIcon from '../../assets/images/footer-icono-linkedin.svg';

function Footer() {
  const menuItems = [
    { path: '/', label: 'TOYO' },
    { path: '/equipos', label: 'EQUIPOS' },
    { path: '/noticias', label: 'NOTICIAS' },
    { path: '/contacto', label: 'CONTACTO' },
    { path: '/tienda', label: 'TIENDA' }
  ];

  const socialLinks = [
    { icon: instagramIcon, url: 'https://www.instagram.com/toyoesports/', label: 'Instagram' },
    { icon: twitterIcon, url: 'https://x.com/ToyoEsports', label: 'Twitter' },
    { icon: tiktokIcon, url: 'https://www.tiktok.com/@toyoesports', label: 'TikTok' },
    { icon: youtubeIcon, url: 'https://www.youtube.com/@TOYOESPORTS', label: 'YouTube' },
    { icon: twitchIcon, url: 'https://www.twitch.tv/toyoesports', label: 'Twitch' },
    { icon: discordIcon, url: 'https://discord.gg/nvFsMqrah2', label: 'Discord' },
    { icon: linkedinIcon, url: 'https://www.linkedin.com/company/toyo-esports/', label: 'LinkedIn' }
  ];

  return (
    <footer className="bg-brand-white border-t border-brand-dark/10 relative overflow-hidden">
      <div className="container mx-auto px-4 py-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Columna izquierda con toda la información */}
          <div className="space-y-6">
            {/* Logo y nombre */}
            <div className="flex items-center gap-4">
              <img src={isologo} alt="Toyo Logo" className="w-16 h-16" />
              <h2 className="text-4xl font-morganite text-brand-dark tracking-wider">TOYO</h2>
            </div>

            {/* Descripción */}
            <p className="text-brand-dark max-w-md text-sm font-helvetica">
              Una organización profesional de gaming establecida en 2022, 
              comprometida con la excelencia y el desarrollo del talento local e internacional.
            </p>

            <div className="grid grid-cols-1">
              <p className="text-xl font-morganite text-brand-dark">CONSULTAS GENERALES</p>
              <p className="text-brand-dark max-w-md text-sm font-helvetica">Contacto@toyomanagement.company</p>
              <p className="text-xl font-morganite text-brand-dark">PATROCINIOS, EVENTOS Y COLABORACIONES</p>
              <p className="text-brand-dark max-w-md text-sm font-helvetica">Emiliano@toyomanagement.company</p>
            </div>

            {/* Navegación */}
            <nav>
              <ul className="flex flex-wrap gap-x-8 gap-y-2">
                {menuItems.map(item => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className="text-xl font-morganite text-brand-dark hover:text-brand-peach 
                               transition-colors duration-300"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>

            {/* Redes sociales con imágenes */}
            <div className="flex items-center space-x-4">
              {socialLinks.map(social => (
                <a
                  key={social.label}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-opacity duration-300 hover:opacity-70"
                  aria-label={social.label}
                >
                  <img src={social.icon} alt={social.label} className="w-6 h-6" />
                </a>
              ))}
            </div>

            {/* Created by */}
            <div className="text-xs font-helvetica text-brand-dark/60 flex items-center gap-4">
              <span>© 2025 Toyo</span>
              <span>|</span>
              <span>
                Creado por 
                <a 
                  href="https://www.linkedin.com/in/francisco-schlatter/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-brand-dark hover:text-brand-peach transition-colors duration-300 ml-1"
                >
                  Francisco Schlatter
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Imagen de fondo a la derecha */}
      <div className="absolute right-0 top-1/2 transform -translate-y-1/2 h-full opacity-10">
        <img src={puertaJapon} alt="Puerta japonesa decorativa" className="h-full w-auto object-contain" />
      </div>
    </footer>
  );
}

export default Footer;
